import { Tooltip } from "./Tooltip"

export const PaygOrganisationUnavailableFeatureTooltip:React.FunctionComponent = () => {
	return (
		<Tooltip id="unavailable-feature-tooltip" content="This feature is currently unavailable for Organisations with PAYG payment type" />
	)
}